import React from 'react';
import G6Editor from '@antv/g6-editor';
import './style.less';

class Detailpanel extends React.Component {
  createDetailpanel(container) {
    return new G6Editor.Detailpannel({
      container
    });
  }
  getCreateDetailpanel() {
    const { createDetailpanel } = this.props;
    return createDetailpanel ? createDetailpanel : this.createDetailpanel;
  }
  componentDidMount() {
    const { editor } = this.props;
    const createDetailpanel = this.getCreateDetailpanel();
    const detailpanel = createDetailpanel(this.detailpanelContainer);
    editor.add(detailpanel);
  }
  render() {
    return (
    <div className="detailpanel" ref={el => { this.detailpanelContainer = el; }}>
      {this.props.content}
    </div>);
  }
}
export default Detailpanel;


// WEBPACK FOOTER //
// ./src/components/common/flowChartCommon/DetailPanel.js